<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title" v-if="!arquivado">Máquinas</h4> 
          <h4 class="card-title" v-if="arquivado">Máquinas arquivadas</h4> 
          <router-link to="/app/machines/machine">
            <l-button wide type="primary" round v-if="showItem">
              <span class="btn-label">
                <i class="fa fa-plus"  style="margin-right: 5px; margin-top: 3px"></i>
              </span>
              Criar
            </l-button>
          </router-link>
            <l-button wide type="primary"
              style="margin-left: 5px"
              round v-if="showItem" @click="cloneDialog = true">
              <span class="btn-label">
                <i class="fa fa-plus" style="margin-right: 5px; margin-top: 3px"></i>
              </span>
              Clonar
            </l-button>
            <l-button wide type="primary"
              style="margin-left: 5px"
              round v-if="arquivado" @click="arquivado = !arquivado">
              <span class="btn-label">
              </span>
              Máquinas desarquivadas
            </l-button>
            <l-button wide type="primary"
              style="margin-left: 5px"
              round v-if="!arquivado" @click="arquivado = !arquivado">
              <span class="btn-label">
              </span>
              Máquinas arquivadas
            </l-button>

          <!-- <p class="card-category">Here is a subtitle for this table</p> -->
        </div>
        <div>
          <el-input
            v-model="search"
            prefix-icon="el-icon-search"
            style="width: 250px"
            placeholder="Digite para pesquisar"/>
        </div>
        <div class="table-responsive table-full-width">
          <el-table class="table-striped" v-loading="loading" :data="tableData().filter(data => !search || data.location.toLowerCase().includes(search.toLowerCase()) ||
              data.last_communication.toLowerCase().includes(search.toLowerCase()) ||
              data.user.toLowerCase().includes(search.toLowerCase()) )" >
            <el-table-column label="Local" property="location" min-width="180" sortable/>
            <el-table-column label="Filial" property="company_name" min-width="180" sortable v-if="showMatriz"/>
            <el-table-column label="Usuário" property="user" min-width="160" sortable/>
            <el-table-column label="Endereço IP" property="ip" width="240" />
            <el-table-column label="Atualizado em" property="last_communication" width="180" sortable/>
            <el-table-column label="Ações" width="140">
              <div class="td-actions" slot-scope="props">
                <el-tooltip class="item" effect="dark" content="Configurações" placement="top-start">
                  <a
                    v-if="permission('config_vm')  && !props.row.archived || showMatriz"
                    class="btn btn-info btn-link btn-xs"
                    @click="handleDoors(props.$index, props.row)"
                  >
                    <i class="fa fa-gear"></i>
                  </a>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Planograma" placement="top-start">
                  <a
                    v-if="permission('adjustment_vm') && !props.row.archived || showMatriz"
                    class="btn btn-success btn-link btn-xs"
                    @click="handleShelves(props.$index, props.row)"
                  >
                    <i class="fa fa-wrench"></i>
                  </a>
                </el-tooltip>
                <!-- <el-tooltip class="item" effect="dark" content="Planograma" placement="top-start">
                  <a
                    class="btn btn-warning btn-link btn-xs"
                    @click="handleShelves2(props.$index, props.row)"
                  >
                    <i class="fa fa-wrench"></i>
                  </a>
                </el-tooltip> -->
                <el-tooltip class="item" effect="dark" content="Editar" placement="top-start">
                  <a
                    v-if="$store.state.auth.imach  && !props.row.archived"
                    class="btn btn-warning btn-link btn-xs"
                    @click="handleEdit(props.$index, props.row)"
                  >
                    <i class="fa fa-edit"></i>
                  </a>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" v-if="!props.row.archived"
                  content="Arquivar" placement="top-start">
                  <a
                    v-if="permission('delete_vm')"
                    class="btn btn-danger btn-link btn-xs"
                    @click="handleDelete(props.$index, props.row)"
                  >
                    <i class="fa fa-folder"></i>
                    <!-- <i class="fa fa-close"></i> -->
                  </a>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" v-if="props.row.archived"
                  content="Arquivar" placement="top-start">
                  <a
                    v-if="permission('delete_vm')"
                    class="btn btn-danger btn-link btn-xs"
                    @click="handleDeleteOff(props.$index, props.row)"
                  >
                    <i class="fa fa-folder-open"></i>
                    <!-- <i class="fa fa-close"></i> -->
                  </a>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </card>
        <el-dialog center :visible.sync="cloneDialog" title="Clonar máquina">
          <card class="row">
            <form class="form-horizontal">
              <div class="col-sm-12" style="margin-top: 10px">
                <label class="col-sm-6" style="margin-left: -6px" >Maquina ou Locker</label>
                <el-select
                  class="select-default col-sm-12"
                  size="large"
                  placeholder="Selecione"
                  v-model="cloneVM"
                >
                  <el-option
                    v-for="maq in machines"
                    class="select-danger"
                    :value="maq.id"
                    :label="maq.location"
                    :key="maq.id"
                  ></el-option>
                </el-select>
                <div style="margin-left: 6px">
                  <fg-input
                    name="name"
                    label="Nome"
                    v-validate="modelValidations.name"
                    :error="getError('nome')"
                    v-model="name"
                  ></fg-input>
                  <fg-input
                    name="Local"
                    label="Local"
                    v-validate="modelValidations.location"
                    :error="getError('local')"
                    v-model="location"
                  ></fg-input>
                </div>
              </div>
            </form>
          </card>
          <button class="btn btn-danger offset-sm-8" @click="cloneDialog = false">Cancelar</button>&nbsp;

          <el-button
                :loading="btnLoading"
                type="success"
                style="font-size: 1em; float: right;"
                @click="clonar()"
                > Clonar!</el-button>
        </el-dialog>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Tooltip, Loading, Dialog, Button, Select, Option, Checkbox } from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tooltip.name]: Tooltip,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Option.name]: Option,
    [Select.name]: Select,
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      search: '',
      loading: true,
      machines: [],
      cloneDialog: false,
      arquivado: false,
      cloneVM: '',
      name: '',
      location: '',
      btnLoading: false,
      modelValidations: {
        name: {
          required: true
        },
        location: {
          required: true
        },
      }
    };
  },
  computed: {
    showItem() {
      const imach = localStorage.getItem("imach")
      if (imach === 'true') {
        return true
      } else {
        return false
      }
    },
    showMatriz () {
      const matriz = localStorage.getItem("parent_company")
      if (matriz != 'null') {
        return true
      } else {
        return false
      }
    },
  },
  created(){},
  mounted() {
    this.getData()
    this.getListCompany()
    this.$watch('arquivado', ()=>{
      this.getData()
    })
    // setInterval(function() {
    //   window.location.reload()
    // }, this.$store.state.general.timer)
    
  },
  methods: {
    handleShelves(i, row) {
      console.log(row);
      this.$router.push(`/app/machines/machine/${row.id}/shelves`);
    },
    handleShelves2(i, row) {
      console.log(row);
      this.$router.push(`/app/machines/machine/${row.id}/planograma`);
    },
    handleDoors(i, row) {
      console.log(row);
      this.$router.push(`/app/machines/machine/${row.id}/maintenance`);
    },
    handleEdit(i, row) {
      console.log(row);
      this.$router.push(`/app/machines/machine/${row.id}`);
    },
    getData () {
      var ciaID = localStorage.getItem('imachCiaID')
      if (ciaID) {
        ciaID = ciaID
      } else {
        ciaID = ''
      }
        this.$store.dispatch('general/listUser').then(() => {
          this.$store.dispatch("machines/listSort",{sort: '?company=' + ciaID + '&archived=' + this.arquivado}).then(resp => {
            this.machines = resp
            this.tableData()
          })
        }).catch(err => console.log(err));
    },
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Item Criado!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    notifyError() {
      this.$notify({
        message: "Erro</br>Item não Criado!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
    },
    tableData() {
      const machines = this.machines
      const dateConverted = machines.map(v => {
        let user, last_communication
        if (v.last_communication) {
          const d = new Date(v.last_communication);
          const last_communication = d.toLocaleString("pt-BR");
        }
        if (v.user) {
          user = this.$store.state.general.listUser.user_list_info.find(e => e.id == v.user)
          user = user.username
        }
        return { ...v, last_communication, user };
      });
      // if (dateConverted[0].id === undefined) {
      //   this.loading = true
      // }
      // if (dateConverted[0].id !== undefined) {
      this.loading = false
      // }
      return dateConverted;
    },
    permission (permissao) {
      var x = this.$store.state.general.permission.permissoes_do_usuario.filter(el => {
        if (el == permissao) {
          return true
        } 
      })
      if (x.length > 0) {
        return true
      }
    },
    getListCompany () {
      this.$store.dispatch("company/list")
    },
    clonar () {
      if(this.name && this.location && this.cloneVM) {
        this.btnLoading = true
        this.$store.dispatch('machines/clone_vm', { id: this.cloneVM, data: {
          location : this.location,
          name : this.name
        }}).then (data => {
          console.log('data', data)
          if (data.status == 201) {
            this.notifySuccess();
            this.getData()
            this.btnLoading = false
            this.cloneDialog = false
          } else {
            this.notifyError()
            this.cloneDialog = false
            this.btnLoading = false
          }
        })
      } else {
        alert('Preencha todos os campos.')
      }
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    handleDelete(i, row) {
      console.log(row);
      const itemName = row.location;
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a arquivar a máquina ${itemName}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, arquive!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("machines/updatePatch", { item : {
                                                                  id: row.id,
                                                                  archived: true
                                                                  } }).then(res => {
            if (res.status !== 500) {
              swal.fire({
                title: "Pronto!",
                text: `${itemName} arquivada.`,
                icon: "success",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false
              })
              this.getData()
            } else {
              swal.fire({
                title: "Ops!",
                text: `${itemName} não arquivada.`,
                icon: "error",
                confirmButtonClass: "btn btn-info btn-fill",
                buttonsStyling: false
              });
            }
          }).catch(err => {
            console.log('catch', err)
          })
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `${itemName} não arquivada.`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    handleDeleteOff(i, row) {
      console.log(row);
      const itemName = row.location;
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a desarquivar a máquina ${itemName}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, desarquive!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("machines/updatePatch", { item : {
                                                                  id: row.id,
                                                                  archived: false
                                                                  } }).then(res => {
            if (res.status !== 500) {
              swal.fire({
                title: "Pronto!",
                text: `${itemName} desarquivada.`,
                icon: "success",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false
              })
              this.getData()
            } else {
              swal.fire({
                title: "Ops!",
                text: `${itemName} não desarquivada.`,
                icon: "error",
                confirmButtonClass: "btn btn-info btn-fill",
                buttonsStyling: false
              });
            }
          }).catch(err => {
            console.log('catch', err)
          })
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `${itemName} não desarquivada.`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
.card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
}
</style>
